export default "__VITE_ASSET__JhwmBKOg__"